import { AccountInfo, EventType } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

export const MsalAccountContext = createContext<AccountInfo | null>(null);

export function useMsalAccount() {
  const msalAccount = useContext(MsalAccountContext);

  return msalAccount;
}

export function MsalAccountProvider({ children }: { children: ReactNode }) {
  const { instance } = useMsal();
  const [msalAccount, setMsalAccount] = useState<AccountInfo | null>(null);

  useEffect(() => {
    const callbackId = instance.addEventCallback((event) => {
      if (
        event.eventType === EventType.LOGIN_SUCCESS ||
        event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
      ) {
        instance.setActiveAccount((event.payload as FIXME).account);
        setMsalAccount((event.payload as FIXME).account);
      }
    });

    return () => {
      if (callbackId) {
        instance.removeEventCallback(callbackId);
      }
    };
  }, [instance, setMsalAccount]);

  return (
    <MsalAccountContext.Provider value={msalAccount}>
      {children}
    </MsalAccountContext.Provider>
  );
}
